
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shared/[noteId]",
      function () {
        return require("private-next-pages/shared/[noteId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shared/[noteId]"])
      });
    }
  